document.addEventListener('DOMContentLoaded', () => {
  function handleDetailsState() {
    const detailsElements = document.querySelectorAll('footer details');
    const viewportWidth = window.innerWidth;

    detailsElements.forEach((details) => {
      if (viewportWidth >= 990) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });
  }

  // Run once on load
  handleDetailsState();

  // Run on resize
  window.addEventListener('resize', handleDetailsState);
});